import { Component, OnInit } from '@angular/core';
import { AuditLogsService } from '@data/auditReports/audit-logs.service';
import { LoadPanelOption } from '@shared/common-components/load-panel/load-panel.component';
import { CommonDataService } from '@shared/services/common-data.service';
import { PermissionService } from '@shared/services/permission.service'; // Generated by Copilot
import { NotificationService } from '@shared/services/notification.service';

interface ActivityLogs{
  entity:string|null;
  title:string|null;
  weekendingDate:Date|string|null;
  modifiedOn:Date|string|null;
  modifiedBy:string;
}

@Component({
    selector: 'app-activity-tacker',
    templateUrl: './activity-tacker.component.html',
    styleUrls: ['./activity-tacker.component.less'],
    standalone: false
})
export class ActivityTackerComponent implements OnInit {

  loadingData=true;

  showLoadPanel=false;
  loadPanelOption:LoadPanelOption={
    closeOnOutsideClick:false,
    message:"loading...",
    visible:true,
    showPane:true,
    ofPosition:'#publishHistoryGrid',
    shadingColor:'rgba(0,0,0,0.05)'
  };

  activityList:ActivityLogs[]=[];

  displayColumns = [
    { caption: 'Entity', dataField: 'entity', dataType: 'string', format: ""},
    { caption: 'Title', dataField: 'title', dataType: 'string', format: ""},
    { caption: 'Weekending Date', dataField: 'weekendingDate', dataType: 'date', format: "MM/dd/yy"},
    { caption: 'Modified On', dataField: 'modifiedOn', dataType: 'date', format: "MM/dd/yyyy, hh:mm:ss aa"},
    { caption: 'Modified By', dataField: 'modifiedBy', dataType: 'string', format: ""},
  ];
  showACAdmin: boolean = true;
  disACAdmin: boolean = false;

  constructor(private _aud: AuditLogsService, private commonServices: CommonDataService, private _notify: NotificationService, private permissionService: PermissionService){
    // Permission check — use numeric permissionId via PermissionService — Generated by Copilot
    if(this.permissionService.hasReadWriteAccess('Admin')){
			this.showACAdmin = true;
		}else if(this.permissionService.hasReadOnlyAccess('Admin')){
			this.showACAdmin = true;
			this.disACAdmin=true;
		}else{
			this.showACAdmin = false;
		}
    this.loadingData=true;
    this.fetchActivityData();
  }

  ngOnInit(): void {
  }

  fetchActivityData(){
    if(!this.loadingData)
      this.showLoadPanel=true;
    this._aud.getActivityData().subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          if(r.serviceResult)
            this.activityList=r.serviceResult;
          else
            this.activityList=[];
          this.showLoadPanel=false;
          this.loadingData=false;
        }
      }
    );
  }

  ngOnDestroy(){
    this._notify.removeErrorOnTabChange('activity-tracker');
  }

}
